'use strict';

var FareChangeMetricHeatmapService = function FareChangeMetricHeatmapService() {
  var heatmapColors = require('../config/heatMapMetricToCellColor.json');
  var currentMetric;
  var ranges;
  function setCurrentMetric(metric) {
    currentMetric = metric;
  }
  function getCurrentMetric() {
    return currentMetric;
  }
  function setCurrentRanges(newRanges) {
    ranges = newRanges;
  }
  function getCurrentRanges() {
    return ranges;
  }
  function getHeatMapColor(metric) {
    metric = metric || getCurrentMetric();
    return heatmapColors[metric];
  }
  return {
    setCurrentMetric: setCurrentMetric,
    getCurrentMetric: getCurrentMetric,
    setCurrentRanges: setCurrentRanges,
    getCurrentRanges: getCurrentRanges,
    getHeatMapColor: getHeatMapColor
  };
};
FareChangeMetricHeatmapService.$inject = [];
module.exports = FareChangeMetricHeatmapService;